import { useIntl } from "react-intl";
import { SchedulingType, SchedulingTypeReviewLabelIdMap } from "../../../../../../enums/taskType";
import { Scheduling } from "../../../../../../models/schedule";
import {
  MaintenanceMonitoringStatusLabelIdMap,
  MaintenanceMonitoringStepLabelIdMap,
} from "../../../../../../enums/maintenanceMonitoring";

import "./styles.css";

interface ISchedulingCardProps {
  task: Scheduling;
  handleScheduling: (scheduling: Scheduling) => void;
}

const SchedulingCard = ({ task, handleScheduling }: ISchedulingCardProps) => {
  const intl = useIntl();
  const primaryColor = (): string => {
    if (task.checkup?.type === SchedulingType.PREVENTIVA)
      return "highlight-dark";
    if (task.checkup?.type === SchedulingType.CORRETIVA) return "rating-2";
    return "";
  };

  const getSecondaryColor = (): string => {
    if (task.checkup?.type === SchedulingType.PREVENTIVA)
      return "highlight-lighter";
    if (task.checkup?.type === SchedulingType.CORRETIVA)
      return "card-secondary";
    return "";
  };

  const translateStatus = (status: string): string => {
    return intl.formatMessage({
      id:
        MaintenanceMonitoringStepLabelIdMap[
          status as keyof typeof MaintenanceMonitoringStepLabelIdMap
        ] ||
        MaintenanceMonitoringStatusLabelIdMap[
          status as keyof typeof MaintenanceMonitoringStatusLabelIdMap
        ] ||
        "intl-msg:dealership.schedulingCard.unknown",
    });
  };

  return (
    <div className="padding-x-3 height-100pct">
      <div
        className={`
                    container width-100pct height-100pct rounded border display-flex align-items-center cursor-pointer
                    border-color-${primaryColor()} bg-${getSecondaryColor()}
                `}
        onClick={() => handleScheduling(task)}
      >
        <div className="text-size-10 width-100pct">
          <div className="flex items-center justify-end">
            <span className="rounded-full text-center border payment-info truncate">
              {task.maintenanceStatus
                ? intl.formatMessage({ id: "intl-msg:dealership.schedulingCard.status" }, { status: translateStatus(task.maintenanceStatus) })
                : intl.formatMessage({ id: "intl-msg:occurrence.card.notStarted" })}
            </span>
          </div>

          <div
            className={`
                            text-bold padding-bottom-5 text-capitalize truncate
                            text-color-${primaryColor()}
                        `}
          >
            {SchedulingTypeReviewLabelIdMap[task.checkup?.type as SchedulingType]
              ? intl.formatMessage({ id: SchedulingTypeReviewLabelIdMap[task.checkup?.type as SchedulingType] })
              : intl.formatMessage({ id: "intl-msg:dealership.schedulingCard.review" }, { type: task.checkup?.type ?? "" })}
          </div>
          <div className="display-grid grid-cols-2-1fr-max-content truncate">
            <div className="text-bold truncate">{task.asset?.name}</div>
            <div className="text-medium">
              {new Date(task.date).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </div>
          </div>
          <div className="display-grid grid-cols-2-1fr-max-content truncate">
            <div className="text-bold truncate">
              {task.asset?.accountName || "-"}
            </div>
          </div>
          <div className="display-grid grid-cols-2-1fr-max-content">
            <div className={`text-color-gray`}>{task.asset?.group}</div>
            <div>&nbsp;</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SchedulingCard;
